import { Avatar, Box, Button, Divider, Modal } from "@mui/material";
import React, { useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import ProfileFildCard from "../../../seller/pages/Account/ProfileFildCard";
import { useAppSelector } from "../../../Redux Toolkit/Store";
import { style } from "../../../seller/pages/Account/Profile";

const UserDetails = () => {
  const { user } = useAppSelector((store) => store);
  const [open, setOpen] = useState(false);

  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);

  return (
    <div className="flex justify-center py-10">
      <div className="w-full lg:w-[70%]">
        <div className="flex items-center pb-3 justify-between">
          <h1 className="text-2xl font-bold text-gray-600">Personal Details</h1>
          <div>
            <Button
              onClick={handleOpen}
              size="small"
              sx={{ borderRadius: "2.9rem" }}
              variant="contained"
              className="w-16 h-16"
            >
              <EditIcon />
            </Button>
          </div>
        </div>
        <div className="space-y-5">
          <Avatar
            sx={{ width: "10rem", height: "10rem" }}
            src="/836.jpg"
          />
          <div>
            <ProfileFildCard keys="Name" value={user.user?.fullName} />
            <Divider />
            <ProfileFildCard keys="Email" value={user.user?.email} />
            <Divider />
            <ProfileFildCard keys="Mobile" value={user.user?.mobile} />
          </div>
        </div>
      </div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>Update UserProfile</Box>
      </Modal>
    </div>
  );
};

export default UserDetails;
